import { SPACES } from 'common/constants/sizes';
import { openSupportRequest } from 'common/services/zendesk.service';
import Icon from 'components/base/Icon';
import { Separator } from 'components/base/layout-components';
import Text from 'components/base/Text';
import useScopesValidationsModalHandler from 'views/oauth/scopes-validations/useScopesValidationsModalHandler';
import { LBButton } from '@linearb/buzz';

export const UpgrateOAuth2State = ({ sensorName, onReauth }) => {
  return (
    <div className='flex items-center w-full'>
      <ConnectedState />
      <div className='flex flex-1 items-center justify-end'>
        <Text ml='1rem' mr='1rem' size='medium'>
          We’ve upgraded our Jira integration — reconnect now using OAuth 2.0
          for improved security.
        </Text>
        <LBButton onClick={onReauth} variant='outline'>
          Authorize {sensorName}
        </LBButton>
      </div>
    </div>
  );
};

export const PendingValidationState = ({ sensorName, sensor }) => {
  const scopeValidationsHandler = useScopesValidationsModalHandler(sensor);

  return (
    <>
      <Separator height='2rem' margin='0 2rem' />
      <Icon name='warning' color='orangePeel' size='medium' />
      <Text ml='1rem' size='medium'>
        Pending {sensorName} validations
      </Text>
      <div className='flex flex-1 justify-end items-center'>
        <Text ml='1rem' mr='1rem' size='medium'>
          Still missing some {sensorName} scope validations
        </Text>
        <LBButton onClick={scopeValidationsHandler.openModal} variant='outline'>
          Run validations
        </LBButton>
      </div>
    </>
  );
};

export const FailureValidationState = ({ sensorName, onReauth }) => {
  return (
    <>
      <Separator height='2rem' margin='0 2rem' />
      <Icon name='errorOutline' color='shuttleGray' size='medium' />
      <Text ml='1rem' size='medium' width='50%'>
        Not connected
      </Text>
      <div className='flex flex-1 justify-end items-center'>
        <Text ml='1rem' mr='1rem' size='medium'>
          {sensorName} validation failed - insufficient user permissions. Please
          reauthorize to continue
        </Text>
        {onReauth && (
          <LBButton onClick={onReauth} variant='outline'>
            Authorize {sensorName}
          </LBButton>
        )}
      </div>
    </>
  );
};

export const InactiveState = ({ sensorName, onReauth }) => {
  return (
    <>
      <Separator height='2rem' margin='0 2rem' />
      <Icon name='warning' color='orangePeel' size='medium' />
      <Text ml='0.4rem' size='medium'>
        Something went wrong with your {sensorName} connection
      </Text>
      <Separator height='2rem' margin='0 1.25rem' />
      {onReauth && (
        <>
          <Text
            size='medium'
            color='chambray'
            cursor='pointer'
            onClick={onReauth}
          >
            Reauthorize
          </Text>
          <Separator height='2rem' margin='0 1.25rem' />
        </>
      )}
      <Text
        size='medium'
        color='chambray'
        cursor='pointer'
        onClick={openSupportRequest}
      >
        Contact support
      </Text>
    </>
  );
};

const ConnectionState = ({ text, icon, color }) => {
  return (
    <>
      <Separator height='2rem' margin='0 2rem' />
      <Icon name={icon} color={color} size='smaller' />
      <Text size='medium' color={color} pl={SPACES.small}>
        {text}
      </Text>
    </>
  );
};

export const ConnectedState = () => (
  <ConnectionState icon='successOutline' color='funGreen' text='Connected' />
);
export const NotConnectedState = () => (
  <ConnectionState
    icon='errorOutline'
    color='shuttleGray'
    text='Not Connected'
  />
);
export const NotSetupState = () => (
  <ConnectionState icon='NotSetup' color='shuttleGray' text='Not Set Up' />
);
export const NotActiveState = () => (
  <ConnectionState icon='NotSetup' color='shuttleGray' text='Not Active' />
);
export const FailedState = () => (
  <ConnectionState
    icon='errorOutline'
    color='shuttleGray'
    text='Failed to connect'
  />
);
